import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/pages/fuel-prices_page.css";
import Header from "../components/Header.jsx";
import Loader from "../components/Loader";
import { fetchFuelPrices, syncFuelPrices } from "../services/fuelPriceService";

const FuelPricesPage = () => {
  const [prices, setPrices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSyncing, setIsSyncing] = useState(false);

  const loadPrices = async () => {
    setIsLoading(true);
    try {
      const data = await fetchFuelPrices().catch((err) => {
        if (err.response?.status === 204) return [];
        throw err;
      });

      setPrices(Array.isArray(data) ? data : []);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Ошибка загрузки цен на ГСМ", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSync = async () => {
    setIsSyncing(true);
    try {
      const data = await syncFuelPrices();
      setPrices(Array.isArray(data) ? data : []);
      toast.success("Цены успешно обновлены", {
        position: "bottom-left",
        autoClose: 3000
      });
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Ошибка обновления цен", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setIsSyncing(false);
    }
  };

  useEffect(() => {
    loadPrices();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const fuelOrder = ["АИ-100", "АИ-95", "B-POWER", "АИ-92", "ДТ", "СУГ"];

  const sortedPrices = [...prices].sort((a, b) => {
    const indexA = fuelOrder.indexOf(a.productName);
    const indexB = fuelOrder.indexOf(b.productName);
    const orderA = indexA === -1 ? fuelOrder.length : indexA;
    const orderB = indexB === -1 ? fuelOrder.length : indexB;
    return orderA - orderB;
  });

  return (
    <div className="fuel-prices-page">
      <Header />
      <ToastContainer />

      {isLoading ? (
        <div className="loader-wrapper">
          <Loader />
          <p className="loading-text">Загрузка цен на ГСМ...</p>
        </div>
      ) : (
        <div className="fuel-prices-page_content">
          <div className="fuel-prices_section">
            <div className="fuel-prices_header">
              <h3 className="section-title">Цены на ГСМ</h3>
              <button
                className="sync-btn"
                onClick={handleSync}
                disabled={isSyncing}
              >
                {isSyncing ? "Обновление..." : "Обновить данные"}
              </button>
            </div>
            <p className="fuel-prices_info">
              Автообновление каждый день в 00:00
            </p>
            {sortedPrices.length > 0 ? (
              <div className="fuel-prices_table">
                <div className="fuel-prices_table-header">
                  <span className="table-cell">Топливо</span>
                  <span className="table-cell">Цена (сом)</span>
                  <span className="table-cell">Тип</span>
                  <span className="table-cell">Обновлено</span>
                </div>
                {sortedPrices.map((item) => (
                  <div key={item.id} className="fuel-prices_table-row">
                    <span className="table-cell fuel-name">
                      <span
                        className="fuel-color-dot"
                        style={{ backgroundColor: `#${item.productColor}` }}
                      ></span>
                      {item.productName}
                    </span>
                    <span className="table-cell fuel-price">{item.salePrice}</span>
                    <span className="table-cell">{item.productType}</span>
                    <span className="table-cell">{formatDate(item.lastUpdated)}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="empty-list-label">
                Данные отсутствуют. Нажмите "Обновить данные" для загрузки цен.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FuelPricesPage;
